(async function() {
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  const utmCampaign = getQueryParam('utm_campaign');

  if (utmCampaign) {
    // Nome del cookie → "utm_campaign"
    document.cookie =
      "utm_campaign=" + encodeURIComponent(utmCampaign) +
      "; path=/; max-age=" + (7*24*60*60) + "; SameSite=Lax";
  }
})();